import { useParams } from "react-router-dom";
import { WorkflowEditFlow } from "./workflow-edit-flows";
import { useWorkflowQuery } from "@babackapp/private-api-client/client/use-workflow-query";
import { WorkflowPageProvider } from "./use-workflow-context";

export default function Workflow() {
  const { shopId, workflowId } = useParams<{
    shopId: string;
    workflowId: string;
  }>();
  const { data } = useWorkflowQuery(shopId!, workflowId!);
  if (!data) return <></>;

  return (
    <WorkflowPageProvider currentWorkflow={data}>
      <WorkflowEditFlow />;
    </WorkflowPageProvider>
  );
}
